import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'okeey-cash-benefit',
  standalone: true,
  imports: [TranslateModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './okeey-cash-benefit.component.html',
  styleUrl: './okeey-cash-benefit.component.scss'
})
export class OkeeyCashBenefitComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;
  private nextButton: HTMLElement;
  private prevButton: HTMLElement;

  benefit: any = {
    title: 'okeeyCash.benefit.title',
    prepaidCard: 'okeeyCash.benefit.prepaidCard',
    cards: [
      {
        img: '/assets/img/my-okeey-cash/benefit/apply-anywhere.svg',
        title: 'okeeyCash.benefit.applyAnywhere',
        body: 'okeeyCash.benefit.applyAnywhereDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/mexican-ID.svg',
        title: 'okeeyCash.benefit.mexicanId',
        body: 'okeeyCash.benefit.mexicanIdDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/simple-requirement.svg',
        title: 'okeeyCash.benefit.simpleRequirement',
        body: 'okeeyCash.benefit.simpleRequirementDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/global-acceptance.svg',
        title: 'okeeyCash.benefit.globalAcceptance',
        body: 'okeeyCash.benefit.globalAcceptanceDesription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/constant-accessibility.svg',
        title: 'okeeyCash.benefit.constantAccessibility',
        body: 'okeeyCash.benefit.constantAccessibilityDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/incentive-referrals.svg',
        title: 'okeeyCash.benefit.IncentiveReferral',
        body: 'okeeyCash.benefit.IncentiveReferralDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/direct-deposit.svg',
        title: 'okeeyCash.benefit.directDeposit',
        body: 'okeeyCash.benefit.directDepositDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/loading-option.svg',
        title: 'okeeyCash.benefit.loadingOption',
        body: 'okeeyCash.benefit.loadingOptionDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/insured-account.svg',
        title: 'okeeyCash.benefit.insuredAccount',
        body: 'okeeyCash.benefit.insuredAccountDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/monthly-fee.svg',
        title: 'okeeyCash.benefit.monthlyFees',
        body: 'okeeyCash.benefit.monthlyFeesDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/customer-fee.svg',
        title: 'okeeyCash.benefit.customerServiceFee',
        body: 'okeeyCash.benefit.customerServiceFeeDescription'
      },
      {
        img: '/assets/img/my-okeey-cash/benefit/hidden-fee.svg',
        title: 'okeeyCash.benefit.hiddenFees',
        body: 'okeeyCash.benefit.hiddenFeesDescription'
      }
    ]
  };
  public cardChunks: any[] = [];

  constructor(
    public _router: Router,
    private renderer: Renderer2
  ) {}

  public ngOnInit(): void {
    this.cardChunks = this.chunkArray(this.benefit.cards, 4);
  }

  public ngAfterViewInit(): void {
    this.nextButton = document.querySelector('.swiper-button-next') as HTMLElement;
    this.prevButton = document.querySelector('.swiper-button-prev') as HTMLElement;
    this.addScrollToTopListeners();
  }

  public chunkArray(arr: any[], chunkSize: number): any[] {
    const results = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      results.push(arr.slice(i, i + chunkSize));
    }
    return results;
  }

  public goToOkeeyCash(): void {
    this._router.navigate(['workspace', 'my-okeey-cash']);
  }

  private addScrollToTopListeners(): void {
    if (this.nextButton && this.prevButton) {
      this.renderer.listen(this.nextButton, 'click', this.scrollToTop.bind(this));
      this.renderer.listen(this.prevButton, 'click', this.scrollToTop.bind(this));
    }
  }

  private scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
